export default class Popup {

    constructor() {
        this.initPopup();
    }

    initPopup() {

        if (localStorage.getItem('popupShown') === null) {

            const popUp = $(".popup");

            $(popUp).find(".close").click(function () {
                $(popUp).fadeOut(500);
                localStorage.setItem('popupShown', 'true')
            });

            setTimeout(function () {
                $(popUp).fadeIn(500);
            }, 4000);
        }
    }
}